import {useContextElement} from "../../context/Context";
import {Link} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import QuantitySelect from "./QuantitySelect";
import SizePicker from "../product-details/SizePicker";

export default function ProductCardSingle({
                                              product,
                                              styleClass = "style-list",
                                              tooltipDirection = "left",
                                              textCenter = false,
                                              ratioClass = "",
                                          }) {
    const imageSrc =
        product.coverImage || product.images?.[0]?.coverImage || "/product-placeholder.png";

    const [currentImage, setCurrentImage] = useState(imageSrc);
    const [quantity, setQuantity] = useState(1);
    const [selectedVariantGuid, setSelectedVariantGuid] = useState(null);
    const [activeColor, setActiveColor] = useState("Black");
    const [sizeWarning, setSizeWarning] = useState(false);


    const {
        setCartLoading,
        addProductToCart,
        isAddedToCartProducts,
        fetchProductBySlug,
        reloadCart,

    } = useContextElement();

    const variants = Array.isArray(product?.variants) ? product.variants : [];

    // seçili varyant
    const selectedVariant =
        variants.find(v => v.guid === selectedVariantGuid) || null;


    const maxStock = (() => {
        const n = Number(selectedVariant?.quantity);
        return Number.isFinite(n) ? n : 5; // quantity yoksa 5 sınırı kullan
    })();

    const allOutOfStock = useMemo(
        () => !(product?.variants?.some(v => Number(v.quantity) > 0)),
        [product]
    );

    const canAddToCart =
        !!selectedVariantGuid && Number(selectedVariant?.quantity) > 0 && !allOutOfStock;


// Varyant değiştiğinde quantity sınırı aşmasın:
    useEffect(() => {
        if (!variants.length) {
            setSelectedVariantGuid(null);
            setQuantity(1);
            return;
        }

        // kullanıcı zaten bir beden seçtiyse bozma
        if (selectedVariantGuid && variants.some(v => v.guid === selectedVariantGuid)) return;

        const sizePriority = ["M", "L", "S", "XL", "XS"];
        let pick = null;

        // öncelik sırasına göre stoklu ilk bedeni bul
        for (const sz of sizePriority) {
            pick = variants.find(v =>
                v.size === sz && (v.isStock ?? true) && Number(v.quantity) > 0
            );
            if (pick) break;
        }

        // hâlâ yoksa herhangi stoklu, o da yoksa ilk varyant
        if (!pick) {
            pick = variants.find(v => (v.isStock ?? true) && Number(v.quantity) > 0) || variants[0];
        }

        setSelectedVariantGuid(pick?.guid ?? null);
        setQuantity(1);
        setSizeWarning(false);
        // product değişince yeniden seç (slug iyi bir anahtar)
    }, [product?.slug, variants.length]); // eslint-disable-line react-hooks/exhaustive-deps

    // varyant veya max stok değiştiğinde miktarı clamp et
    useEffect(() => {
        const max = Math.max(1, Number(maxStock) || 1);
        setQuantity(q => {
            let nq = q;
            if (nq > max) nq = max;
            if (nq < 1) nq = 1;
            return nq;
        });
    }, [maxStock]);



    useEffect(() => {
        setCurrentImage(imageSrc);

    }, [product]);

    return (
        <div
            className={`card-product ${styleClass}`}
            data-availability="In stock"
            data-brand="Vineta"
        >
            <div className={` card-product-wrapper ${ratioClass}`}>
                <Link to={`/product-detail/${product.slug}`} className="product-img">
                    <img
                        className="img-product lazyload"
                        alt="image-product"
                        src={currentImage}
                        width={684}
                        height={972}
                    />
                    <img
                        className="img-hover lazyload"
                        src={product.imgHover || currentImage}
                        alt="image-product"
                        width={684}
                        height={972}
                    />
                </Link>
            </div>

            <div className="card-product-info tf-product-info-wrap w-100">
                <div className="info-list">

                    <Link
                        to={`/product-detail/${product.slug}`}
                        className="name-product link fw-medium text-md"
                    >
                        {product.name}
                    </Link>

                    <span className="brand-product">{product.category.name}</span>
                    <p className="price-wrap fw-medium">
                        <span className="price-new text-primary">£{Number(product.totalPrice).toFixed(2)}</span>
                    </p>

                    <p className="decs text-sm text-main text-line-clamp-2">
                        {product.detail}
                    </p>


                </div>

                <div className="tf-product-info-variant">

                    <SizePicker
                        selectedGuid={selectedVariantGuid}
                        onSelect={setSelectedVariantGuid}
                        variants={product.variants}
                    />

                </div>


                <div className="tf-product-total-quantity">
                    {sizeWarning && (
                        <div
                            style={{
                                marginBottom: "10px",
                                color: "red",
                                fontSize: "12x",
                                fontWeight: "500",
                            }}
                        >
                            Please select a size before adding to cart!
                        </div>
                    )}

                    <div
                        className="group-btn"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "16px", // butonlar arası boşluk
                            flexWrap: "wrap" // küçük ekranlarda alt alta geçer
                        }}
                    >
                        <QuantitySelect
                            quantity={quantity}
                            setQuantity={setQuantity}
                            max={maxStock}
                            min={1}
                        />

                        <a
                            href={canAddToCart ? "#shoppingCart" : undefined}
                            {...(canAddToCart ? {'data-bs-toggle': 'offcanvas'} : {})}
                            onClick={async (e) => {
                                if (!canAddToCart) {
                                    e.preventDefault();
                                    // tamamen stok yoksa uyarı göstermeye gerek yok; sadece beden seçilmemişse göster
                                    setSizeWarning(!allOutOfStock && !selectedVariantGuid);
                                    return;
                                }

                                setSizeWarning(false);
                                await addProductToCart(product.slug, quantity, selectedVariantGuid);
                                await reloadCart();
                            }}
                            className={`tf-btn btn-main-product animate-btn ${!canAddToCart ? 'disabled opacity-50 pointer-events-none' : ''}`}
                            aria-disabled={!canAddToCart}
                        >
                            {allOutOfStock
                                ? "Out of stock"
                                : isAddedToCartProducts(product.slug, selectedVariantGuid)
                                    ? "Already Added"
                                    : "Add to cart"}
                        </a>

                    </div>
                </div>

            </div>
        </div>
    );
}
